import {css, Stack, styled, SwipeableDrawer} from '@mui/material';

export const Puller = styled(Stack)`
	width: 30px;
	height: 6px;
	border-radius: 12px;
	${({theme}) => css`
		background-color: ${theme.colors.gray['30Percent']};
	`}
`;

export const StyledSwipeableDrawer = styled(SwipeableDrawer)`
	& .MuiDrawer-paper {
		border-radius: 8px 8px 0 0;
	}
`;
